import { addToCart, serializeForm } from 'lib-utils';

// Size Guide

document.addEventListener('DOMContentLoaded', () => {
  const $forms = Array.from(document.querySelectorAll('.js-product-form'));

  const SELECTORS = {
    sizeGuideButton: '.js-product-sizeguide__button',
    sizeGuide: '.js-size-guide',
  };
  const $sizeGuideButton = document.querySelector(SELECTORS.sizeGuideButton);
  const $sizeGuide = document.querySelector(SELECTORS.sizeGuide);
  const $sizeGuidePage = document.querySelector('.js-product-sizeguide__page');

  if ($forms.length) {
    for (const $form of $forms) {
      const $submitButton = $form.querySelector('[type="submit"]');
      const formId = $form.getAttribute('id');
      const $quantityInput = document.querySelector(
        `nova-quantity-input[data-form-id="${formId}"]`
      );

      $form.addEventListener('submit', (event) => {
        event.preventDefault();

        $submitButton.setAttribute('disabled', true);
        $submitButton.classList.add('loading');

        const serializedData = serializeForm($form);
        const formData = JSON.parse(serializedData);
        formData['quantity'] = $quantityInput.value;

        addToCart(formData).then(() => {
          $submitButton.removeAttribute('disabled');
          $submitButton.classList.remove('loading');
        });
      });
    }
  }

  const toggleSizeGuide = () => {
    document.dispatchEvent(new CustomEvent('nova:size-guide:toggle'));
  };

  if ($sizeGuideButton) {
    $sizeGuideButton.addEventListener('click', () => {
      toggleSizeGuide();
    });
  }

  // Only attach events if $sizeGuide exists
  if ($sizeGuide) {
    document.addEventListener('nova:size-guide:toggle', () => {
      document.querySelector('html').classList.toggle('no-scroll');
      if ($sizeGuide.open) {
        $sizeGuide.close();
      } else {
        $sizeGuide.show();
      }
    });

    $sizeGuide.addEventListener('sl-hide', () => {
      document.querySelector('html').classList.toggle('no-scroll');
    });
  }

  if ($sizeGuidePage) {
    const $tables = Array.from($sizeGuidePage.querySelectorAll('table'));
    for (const table of $tables) {
      const $rows = Array.from(table.querySelectorAll('tr'));
      if ($rows.length > 1) {
        table.classList.add('js-table-multiple-rows');
      } else {
        table.classList.add('js-table-single-row');
      }

      const scrollBar = document.createElement('div');
      scrollBar.classList.add('js-size-guide__table-scrollbar');
      table.parentElement.insertBefore(scrollBar, table.nextSibling);

      if (table.scrollWidth === table.clientWidth) {
        scrollBar.classList.add('hidden');
      } else {
        scrollBar.classList.remove('hidden');
      }

      const updateScrollBar = () => {
        const progress =
          ((table.scrollLeft + table.clientWidth) / table.scrollWidth) * 100;

        scrollBar.style.background = `linear-gradient(to right, var(--nova-utility-grey-4, #4b4b4b) ${progress}%, var(--nova-color-grey, #efefed) ${progress}%)`;
      };

      updateScrollBar();

      window.addEventListener('nova:resize-width', () => {
        updateScrollBar();
        if (table.scrollWidth === table.clientWidth) {
          scrollBar.classList.add('hidden');
        } else {
          scrollBar.classList.remove('hidden');
        }
      });

      table.addEventListener('scroll', updateScrollBar);
    }
  }
});

// Product Slider

function getMainSliderSettings(thumbsSwiper) {
  return {
    loop: false,
    spaceBetween: 16,
    // Removed zoom settings for lightGallery integration
    slidesPerView: 1.6,
    grid: { rows: 0 },
    breakpoints: {
      640: {
        slidesPerView: 1.7,
      },
      768: {
        slidesPerView: 2.5,
        grid: { rows: 0 },
      },
      990: {
        slidesPerView: 2,
        grid: { rows: 12, fill: 'row' },
      },
    },
    thumbs: { swiper: thumbsSwiper },
  };
}

// Returns configuration settings for the thumbs slider.
function getThumbsSliderSettings() {
  console.debug('Generating thumbs slider settings');
  return {
    loop: false,
    spaceBetween: 8,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesProgress: true,
  };
}

// Generic initializer for a Swiper slider.
function initSwiperSlider(sliderEl, config) {
  if (!sliderEl) {
    return null;
  }
  return new Swiper(sliderEl, config);
}

// lightGallery initialization
function initLightGallery() {
  const galleries = document.querySelectorAll('.product-slider__main');

  galleries.forEach((gallery) => {
    // Destroy existing lightGallery instance if it exists
    if (gallery.lgInstance) {
      gallery.lgInstance.destroy(true);
    }

    // Initialize new lightGallery instance
    gallery.lgInstance = lightGallery(gallery, {
      plugins: [lgZoom],
      selector: '.swiper-slide a', // Target the anchor tags inside slides
      licenseKey: 'D9112F1B-A65B-42FD-A4A5-890CBF56BA21',
      speed: 500,
      download: false,
      counter: true,
      getCaptionFromTitleOrAlt: false,
      zoom: true,
      scale: 1,
      actualSize: true,
      closeOnTap: true,
      showCloseIcon: true,
      hideScrollbar: true,
    });
  });
}

// Initializes the default sliders that are visible on the page.
// It finds the main slider and its corresponding thumbs slider that do not have the .hidden class.
function initializeDefaultSliders() {
  const mainEl = document.querySelector('.product-slider__main:not(.hidden)');
  const thumbsEl = document.querySelector(
    '.product-slider__thumbs:not(.hidden)'
  );

  if (mainEl && thumbsEl) {
    console.debug('Default sliders found. Main:', mainEl, 'Thumbs:', thumbsEl);
    const thumbsSwiper = initSwiperSlider(thumbsEl, getThumbsSliderSettings());
    const mainSwiper = initSwiperSlider(
      mainEl,
      getMainSliderSettings(thumbsSwiper)
    );

    return { mainSwiper, thumbsSwiper };
  } else {
    console.warn('Default visible sliders not found.');
    return null;
  }
}

// Initializes sliders based on the provided data handle.
function initializeSlidersForHandle(handle) {
  const sliderMain = document.querySelector(
    `.product-slider__main[data-slider="${handle}"]`
  );
  if (!sliderMain) {
    console.warn('No main slider found for handle:', handle);
    return;
  }
  const sliderThumbs = document.querySelector(
    `.product-slider__thumbs[data-slider="thumbs-${handle}"]`
  );

  // Hide all main and thumbs sliders.
  document
    .querySelectorAll('.product-slider__main')
    .forEach((slider) => slider.classList.add('hidden'));
  document
    .querySelectorAll('.product-slider__thumbs')
    .forEach((slider) => slider.classList.add('hidden'));

  // Show the target sliders.
  sliderMain.classList.remove('hidden');
  if (sliderThumbs) {
    sliderThumbs.classList.remove('hidden');
  }

  // Initialize thumbs slider first.
  const thumbsSwiper = sliderThumbs
    ? initSwiperSlider(sliderThumbs, getThumbsSliderSettings())
    : null;
  // Initialize main slider with the thumbsSwiper instance.
  initSwiperSlider(sliderMain, getMainSliderSettings(thumbsSwiper));
}

// On DOM load, initialize default sliders and attach event listeners to swatch inputs.
document.addEventListener('DOMContentLoaded', function () {
  initializeDefaultSliders();

  // Initialize lightGallery after sliders are ready (all devices)
  setTimeout(() => {
    initLightGallery();
  }, 100);

  // Attach event listeners for all swatch inputs.
  document.querySelectorAll('.vp__input--color input').forEach((input) => {
    input.addEventListener('click', function (e) {
      const handle = e.target.getAttribute('data-handle');

      // Check if a corresponding main slider exists.
      if (
        document.querySelector(`.product-slider__main[data-slider="${handle}"]`)
      ) {
        initializeSlidersForHandle(handle);

        // Re-initialize lightGallery for the new slider (all devices)
        setTimeout(() => {
          initLightGallery();
        }, 200);
      } else {
        console.debug(
          'No corresponding slider for handle:',
          handle,
          '. No action taken.'
        );
      }
    });
  });
});

// remove loading
const $loadingElements = document.querySelectorAll('.loading');
if ($loadingElements.length) {
  setTimeout(() => {
    $loadingElements.forEach(($loading) =>
      $loading.classList.remove('loading')
    );
  }, 2000);
}

// Klarna translations
function detectLanguageFromUrl() {
  const lang = window.location.pathname.split('/')[1];
  const supportedLangs = ['fr', 'de', 'nl', 'es'];
  return supportedLangs.includes(lang) ? lang : null;
}

function translateKlarnaText(element, lang) {
  const translations = {
    fr: {
      from: 'À partir de ',
      month: '/mois',
      payments: ', ou 4 paiements sans intérêts avec ',
      learnMore: 'En savoir plus',
    },
    de: {
      from: 'Ab ',
      month: '/Monat',
      payments: ', oder 4 zinsfreie Raten mit ',
      learnMore: 'Mehr erfahren',
    },
    nl: {
      from: 'Vanaf ',
      month: '/maand',
      payments: ', of 4 renteloze betalingen met ',
      learnMore: 'Meer informatie',
    },
  };

  const t = translations[lang];
  if (!t) return false;

  // Find and replace text nodes
  const walker = document.createTreeWalker(
    element,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );

  let textNode;
  while ((textNode = walker.nextNode())) {
    let text = textNode.textContent;

    if (text.includes('From ')) {
      textNode.textContent = text.replace('From ', t.from);
    } else if (text.includes('/month')) {
      textNode.textContent = text.replace('/month', t.month);
    } else if (text.includes(', or 4 payments at 0% interest with ')) {
      textNode.textContent = text.replace(
        ', or 4 payments at 0% interest with ',
        t.payments
      );
    }
  }

  // Translate button
  const button = element.querySelector('button');
  if (button && button.textContent.trim() === 'Learn more') {
    button.textContent = t.learnMore;
  }

  return true;
}

function applyKlarnaTranslationIfNeeded() {
  const lang = detectLanguageFromUrl();
  if (!lang) return;

  const host = document.querySelector('klarna-placement');
  if (!host || !host.shadowRoot) return;

  const element = host.shadowRoot.querySelector('.osm-message');
  if (!element) return;

  const rawText = element.textContent.trim();
  if (!rawText.includes('$') || !rawText.includes('From ')) return;

  const success = translateKlarnaText(element, lang);
  if (success) {
    console.log('Klarna text translated to ' + lang);
    return true;
  }

  return false;
}

// Only start checking if we have a supported language (excluding Spanish for Klarna)
const lang = detectLanguageFromUrl();
if (lang && lang !== 'es') {
  // Try translation every 500ms until it works
  const checkInterval = setInterval(function () {
    if (applyKlarnaTranslationIfNeeded()) {
      clearInterval(checkInterval);
    }
  }, 500);

  // Stop trying after 10 seconds
  setTimeout(function () {
    clearInterval(checkInterval);
  }, 10000);
}

//Hide klarna block for international markets
function hideKlarnaBlock() {
  const country = window.Shopify?.country;

  if (country && country !== 'US') {
    const klarnaBlock = document.getElementsByTagName('klarna-placement')[0];
    if (klarnaBlock) {
      klarnaBlock.style.display = 'none';
    }
  }
};

hideKlarnaBlock();

// Clipara: Add influencer's link
function addInfluencerLinksNextToVideos() {
  const container = document.querySelector('#__clipara-embed-contents');
  if (!container) return;

  const images = container.querySelectorAll('picture > img');
  if (!images.length) return;

  images.forEach((img) => {
    const alt = img.getAttribute('alt') || '';

    // Match @handle up to first underscore
    const match = alt.match(/^@([a-zA-Z0-9_.-]+)_/);
    if (!match) return;

    const username = match[1];

    // Prevent duplicate insertion
    if (container.querySelector(`a.influencer-link[href*="${username}"]`)) {
      return;
    }

    const link = document.createElement('a');
    link.href = `https://instagram.com/${username}`;
    link.textContent = `@${username}`;
    link.target = '_blank';
    link.className = 'influencer-link';
    link.style.display = 'block';

    // Try to place it next to the related image
    const targetContainer = img.closest('.keen-slider__slide') || container;
    targetContainer.appendChild(link);
  });
}

//Clipara: Translate h2 title
function translateCliparaTitle(container) {
  const h2Element = container.querySelector('h2');
  if (!h2Element) return;

  const lang = detectLanguageFromUrl();
  if (!lang) return;

  const translations = {
    fr: 'Ce que dit notre communauté',
    de: 'Was unsere community sagt',
    nl: 'Wat onze communiteit zegt',
    es: 'Lo que nuestra Comunidad dice',
  };

  h2Element.textContent = translations[lang] || 'What Our Community Says';

  return h2Element.textContent;
}

// Wait for Clipara container to load
const observer = new MutationObserver((_, obs) => {
  const container = document.querySelector('#__clipara-embed-contents');
  if (container) {
    obs.disconnect();
    translateCliparaTitle(container);
    addInfluencerLinksNextToVideos();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// ============================================
// Preorder Message Handler
// ============================================
// Shows warehouse-specific shipping date when variant has preorder enabled
class PreorderMessageHandler {
  constructor() {
    this.container = document.getElementById('preorder-message-container');
    this.messageText = document.getElementById('preorder-message-text');
    this.variantData = this.loadVariantData();

    if (!this.variantData || !this.container) return;

    this.init();
  }

  // Load preorder data from JSON script tag
  loadVariantData() {
    const dataEl = document.getElementById('variant-preorder-data');
    if (!dataEl) return null;

    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Failed to parse variant preorder data:', e);
      return null;
    }
  }

  init() {
    // Listen for variant changes
    document.addEventListener('variant:change', (e) => {
      const variantId = e.detail?.variant?.id || e.detail?.id;
      if (variantId) {
        this.updateMessage(variantId);
      }
    });

    // Set initial state on page load
    const initialVariantId = this.getSelectedVariantId();
    if (initialVariantId) {
      this.updateMessage(initialVariantId);
    }
  }

  // Get currently selected variant ID from form
  getSelectedVariantId() {
    const variantInput = document.querySelector('[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  // Update message visibility and text based on selected variant
  updateMessage(variantId) {
    const variant = this.variantData.variants[variantId];
    if (!variant) return;

    const warehouse = this.variantData.customerWarehouse;
    const warehouseData = variant[warehouse];

    // Show message if preorder enabled for this warehouse
    if (warehouseData && warehouseData.enabled) {
      const message = warehouseData.date || this.variantData.defaultMessage;
      this.messageText.textContent = message;
      this.container.style.display = 'block';
    } else {
      this.container.style.display = 'none';
    }
  }
}

// Initialize when DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PreorderMessageHandler();
  });
} else {
  new PreorderMessageHandler();
}
